import { useMemo } from 'react'
import _find from 'lodash/find';
import useFastSpringStore from './useFastSpringStore';

export default (productId) => {
  const [{products}] = useFastSpringStore()
  return useMemo(() => _find(products, ['pid', productId]), [productId])
}
